import { createContext, useContext } from "react";

/**
 * Marks a region whose buttons commit something (a dialog's footer), where a button's leading
 * icon stays still on hover; `ModalFooter` provides it. A form's submit button stays still too,
 * by its `type`, without one.
 */
export const IconStillContext = createContext(false);

/** Whether the buttons here are commits, whose icons stay still on hover. */
export function useIconsStill(): boolean {
  return useContext(IconStillContext);
}
